//手Q定位API
var util = require("../util");

var isInMobileQQ = function () {
    return navigator.userAgent.match(/(.*?(iPad|iPhone|iPod).*?QQ\/([\d\.]+).*?)|(.*?\bV1_AND_SQI?_([\d\.]+)(.*?QQ\/([\d\.]+))?.*?)/i)
};


module.exports = function (suc, fail, next) {
    if (!isInMobileQQ()) {
        next();
    } else {
        util.loadScript("//open.mobile.qq.com/sdk/qqapi.js?_bid=152", function () {
            if (!window.mqq || !window.mqq.sensor || !window.mqq.sensor.getLocation) {
                next();
            } else {
                mqq.sensor.getLocation({
                    allowCacheTime: 60
                }, function (retCode, latitude, longitude) {
                    if (retCode == 0 && latitude && longitude) {
                        suc({
                            lat: latitude,
                            lng: longitude
                        });

                    } else {
                        fail.apply(this, Array.prototype.slice.call(arguments, 0));
                    }
                });
            }
        });
    }
};

module.exports.type = "mobileqq";


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/mobileqq.js